
<div class="p-d-flex p-flex-column p-mt-3"  *ngIf="form" [formGroup]="form">
  <!-- Tabela stavki dokumenta -->
  <p-table
    [value]="stavkePrijemnice.controls"
    styleClass="p-datatable-striped p-datatable-gridlines"
    dataKey="redniBroj"
  >
    <!-- START HEADER -->
    <ng-template pTemplate="header">
      <!-- header columns -->
      <tr class="columns">
        <th></th>
        <th style="width: 22%">Naziv</th>
        <th style="width: 15%">Šifra sa otpremnice</th>
        <th style="width: 5%">Količina sa otpremnice</th>
        <th style="width: 5%">Pristigla količina</th>
        <th style="width: 5%">Primljeno</th>
        <th style="width: 5%">Vraćeno</th>
      </tr>
    </ng-template>

    <!-- START BODY -->

    <!-- Rows -->
    <ng-template
      pTemplate="body"
      let-stavka
      let-rowIndex="rowIndex"
      let-expanded="expanded"
    >
      <ng-container formArrayName="stavkeDto">
        <tr [formGroupName]="rowIndex">
          <td>
            <button
              pButton
              type="button"
              icon="fa-regular fa-comment"
              class="p-button-text"
              pTooltip="Unesi komentar za stavku"
              (click)="openDialogKomentar(rowIndex)"
            ></button>
          </td>
          <td>
            <div>Sa otpremnice: <b>{{stavka.get('naziv')?.value}}</b></div>
            <div
              [ngClass]="
                disabledStavka
                  ? 'p-disabled inputFullWidth celija'
                  : 'inputFullWidth celija'
              ">

              <kodit-predmet-stavke-eotpremnica-input
                [predmetStavkeFormGroup]="
                  stavka.get('predmetStavkeDto')
                "
                (onNazivChange)="updateRezultate($event, rowIndex)"
              ></kodit-predmet-stavke-eotpremnica-input>
            </div>
          </td>
          <td>
            <div class="inputFullWidth celija">
              {{stavka.get('sifra')?.value}}
            </div>
          </td>
          <td>
            <div>
              {{stavka.get('kolicina')?.value}}
            </div>
          </td>
          <td>
            <kodit-number-input
              class="ammount p-mr-1 p-ml-1"
              [ctrlMinValue]="0"
              [showButtons]="true"
              [buttonLayout]="'horizontal'"
              [spinnerMode]="'horizontal'"
              [decrementButtonClass]="'p-button-danger'"
              [incrementButtonClass]="'p-button-success'"
              [incrementButtonIcon]="'pi pi-plus'"
              [decrementButtonIcon]="'pi pi-minus'"
              [ctrlOnlyIntegers]="true"
              [formCtrl]="stavka.get('pristiglaKolicina')"
            ></kodit-number-input>
          </td>

          <td>
            <kodit-number-input
              class="ammount"
              [ctrlMinValue]="0"
              [showButtons]="true"
              [buttonLayout]="'horizontal'"
              [spinnerMode]="'horizontal'"
              [decrementButtonClass]="'p-button-danger'"
              [incrementButtonClass]="'p-button-success'"
              [incrementButtonIcon]="'pi pi-plus'"
              [decrementButtonIcon]="'pi pi-minus'"
              [ctrlOnlyIntegers]="true"
              [formCtrl]="stavka.get('primljenaKolicina')"
            ></kodit-number-input>
          </td>

          <td>
            <kodit-number-input
              class="ammount"
              [ctrlMinValue]="0"
              [showButtons]="true"
              [buttonLayout]="'horizontal'"
              [spinnerMode]="'horizontal'"
              [decrementButtonClass]="'p-button-danger'"
              [incrementButtonClass]="'p-button-success'"
              [incrementButtonIcon]="'pi pi-plus'"
              [decrementButtonIcon]="'pi pi-minus'"
              [ctrlOnlyIntegers]="true"
              [formCtrl]="stavka.get('vracenaKolicina')"
            ></kodit-number-input>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>

  <!-- Rezultat pretrage -->
  <div
    class="layout-sidebar-right rezultati"
    [ngClass]="{ 'layout-sidebar-right-active': shouldDisplayRezultate }"
  >
    <kodit-rezultat-pretrage-stavke
      *ngIf="shouldDisplayRezultate"
      [searchValue]="rezultatiSearchValue"
      [excludeTipovePredmeta]="excludeTipovePredmeta"
      (onPredmetStavkeAdd)="handleAddPredmetStavke($event)"
    ></kodit-rezultat-pretrage-stavke>
  </div>

  <!-- Button za dodavanje stavke -->
<!--  <div class="p-d-flex p-mt-3">-->
<!--    <button-->
<!--      pButton-->
<!--      pRipple-->
<!--      type="button"-->
<!--      icon="fas fa-plus"-->
<!--      class="p-button-outlined"-->
<!--      (click)="addEmptyStavka()"-->
<!--      label="Nova stavka"-->
<!--      pTooltip="Dodaj novu stavku na račun"-->
<!--    ></button>-->
<!--  </div>-->

  <!-- Rezultat pretrage -->
<!--  <div-->
<!--    class="layout-sidebar-right rezultati"-->
<!--    [ngClass]="{ 'layout-sidebar-right-active': shouldDisplayRezultate }"-->
<!--  >-->
<!--    <kodit-rezultat-pretrage-stavke-->
<!--      *ngIf="shouldDisplayRezultate"-->
<!--      [searchValue]="rezultatiSearchValue"-->
<!--      [excludeTipovePredmeta]="excludeTipovePredmeta"-->
<!--      (onPredmetStavkeAdd)="handleAddPredmetStavke($event)"-->
<!--    ></kodit-rezultat-pretrage-stavke>-->
<!--  </div>-->
</div>
